import { useTranslation } from 'react-i18next';
import { AbioticStressTag } from '../abiotic-stress-tag/abiotic-stress-tag.component';
import type { StressRiskLevel } from '../../abiotic-stress/domain/abiotic-stress.models';
import { isValidStressRiskLevel } from '../abiotic-stress-tag/abiotic-stress-tag.utils';
import {
  ABIOTIC_STRESS_SECTION_DIVIDER,
  ABIOTIC_STRESS_SECTION_LABEL,
  ABIOTIC_STRESS_SECTION_WRAPPER
} from '../../domain/tests-id.constants';
import { SectionContainer, SectionDivider, SectionLabel, SectionTagWrapper } from './abiotic-stress-section.styles';

interface AbioticStressSectionProps {
  stressRiskLevel: StressRiskLevel | undefined;
  showAbioticStress: boolean | undefined;
  variant: 'field' | 'property';
}

export const AbioticStressSection = ({ stressRiskLevel, showAbioticStress, variant }: AbioticStressSectionProps) => {
  const [t] = useTranslation();

  if (!showAbioticStress || !isValidStressRiskLevel(stressRiskLevel)) return null;

  return (
    <SectionContainer>
      <SectionDivider $variant={variant} data-testid={ABIOTIC_STRESS_SECTION_DIVIDER} />
      <SectionLabel data-testid={ABIOTIC_STRESS_SECTION_LABEL}>{t('pages.regional_overview.abiotic_stress.title')}</SectionLabel>
      <SectionTagWrapper $variant={variant} data-testid={ABIOTIC_STRESS_SECTION_WRAPPER}>
        <AbioticStressTag stressRiskLevel={stressRiskLevel} />
      </SectionTagWrapper>
    </SectionContainer>
  );
};
